<template>
<div>
    <div><h6 class="heading-text my-0 mb-2">Training Evaluation :</h6></div>
    <div class="d-flex flex-row align-items-end gap-3">
        <!-- <div><p class="text my-0">Training Evaluation </p></div> -->
      <div> <p class="text my-0"><input type="number" min="0" max="10" class="form--control" v-model="score"/> / 10 </p></div>
        <div> <Button label="set score" class="qb-btn qb-btn-primary-md" @onClick="setScore(score)"/> </div>
    </div>
</div>
</template>

<script>
import Button from "./ButtonComponent.vue"
// import Input from "./TextFieldComponent.vue"
export default {
    name:"ScoreBoard",
    data(){
        return{
            score:0
        }
    },
    components:{
        Button,
    },
    methods:{
        setScore(val){
            this.$emit("score",val)
        }
    }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.text{
  font-size: $font-size-md;
  color: $dark-200;
}
.heading-text{
  font-size: $font-size-md;
  color: $dark-400;
}
.form--control {
  border: 1px solid rgb(222, 222, 222);
  border-radius: $field-border-radius;
  padding: 6px 10px;
  width: 60px;
}

.form--control::placeholder {
  font-size: 15px;
}


.form--control:focus {
  outline: none;
}
</style>
